import { Icon, IconProps } from '@chakra-ui/react';
import React from 'react';
import { JSX } from 'react/jsx-runtime';

const ArrowDownRight = (
  props: JSX.IntrinsicAttributes &
    Omit<
      React.SVGProps<SVGSVGElement>,
      'as' | 'translate' | keyof IconProps
    > & {
      htmlTranslate?: 'yes' | 'no' | undefined; //www.w3.org/2000/svg'
    } & IconProps & { as?: 'svg' | undefined }
) => {
  return (
    <Icon
      xmlns='http://www.w3.org/2000/svg'
      width='18'
      height='18'
      viewBox='0 0 24 24'
      fill='none'
      stroke='#1e40af'
      strokeWidth='3'
      strokeLinecap='round'
      strokeLinejoin='round'
      {...props}
    >
      <line x1='7' y1='17' x2='17' y2='7'></line>
      <polyline points='7 7 17 7 17 17'></polyline>
    </Icon>
  );
};

export default ArrowDownRight;
